<template>
    <div class="container content-page-wrapper" :class="{'loading': loading}">
        <div class="row py-5">
            <div class="col-12 m-0 p-0">
                <!-- Project Details -->
                <h2 class="pt-5">{{ product_configurator_id === 3 ? $t('Arrange mounting rails') : $t('Arrange lighting line modules') }}</h2>
                <p><span class="lead">{{ planningFields.title }} ({{ $t('No.') }} {{ planningFields.custom_planning_id }})</span><br><router-link :to="{ name: 'plannings.show', params: { id: this.$route.params.id } }" v-if="!firstTimeOpened">{{ $t('Go to overview') }}</router-link></p>

                <!-- Luminaire Line Order Module -->
                <div class="luminaire-line-order-wrapper">
                    <ValidationObserver ref="mountingRailArrangement" v-slot="{ valid, errors }" >
                        <div id="luminaire-line-order-zoom" class="shadow-lg" :style="'width: ' + ( getMountingRailsLength(mountingRailAndModuleArrangement) + (332 * 2) )+'px;'">
                            <div class="luminaire-room-left"></div>
                            <div class="luminaire-room-middle">
                                <div class="luminaire-line-length" :style="'width: ' + getMountingRailsLength(mountingRailAndModuleArrangement) +'px;'">
                                    <p class="lenght-block">
                                        <span class="lenght-label">{{ planningFields.total_lumination_line_length / 100 }} m<span v-if="planningFields.number_of_electrical_feeds_middle > 0"> ({{ $t('Full length incl. electrical center feeds') }})</span></span>
                                    </p>
                                </div>
                                <draggable v-if="mountingRailAndModuleArrangement && mountingRailAndModuleArrangement.length > 0 && !loading"
                                    :list="mountingRailAndModuleArrangement"
                                    :element="'div'"
                                    class="luminaire-line-order"
                                    animation="400"
                                    :group="'mounting-rails'"
                                    filter=".ignore-element"
                                    preventOnFilter: true
                                    :style="'width: ' + getMountingRailsLength(mountingRailAndModuleArrangement) +'px;'">

                                        <div v-for="(mounting_rail, index) in mountingRailAndModuleArrangement"
                                             :id="'mounting-rail-' + mounting_rail.id"
                                             :class="getClassObject(mounting_rail)"
                                             :style="'width:' + getItemLength(mounting_rail) + 'px;' + ((!itemIsMountingRail(mounting_rail)|| mounting_rail.emergency_light ) && moduleDragging ? 'height: 0;overflow:hidden;' : '')"
                                             :key="mounting_rail.id">
                                                <p class="small mounting-rail-title" v-if="product_configurator_id === 3">
                                                    <span v-if="!itemIsMountingRail(mounting_rail)">{{ $t(mounting_rail.title) }}</span>
                                                    <span v-else>{{ $t(getMountingRailConfigurationByTitle(mounting_rail.title).title).slice(-1) === 'n' ? $t(getMountingRailConfigurationByTitle(mounting_rail.title).title.slice(0, -1)) : $t(getMountingRailConfigurationByTitle(mounting_rail.title).title) }}
                                                        <br>
                                                        {{ $t(getMountingRailConfigurationByTitle(mounting_rail.title).connectors) }}
                                                    </span>
                                                </p>
                                                <p class="small mounting-rail-title" v-else>
                                                    <span v-if="mounting_rail.product_subtype === 'intelligence'">{{ $t('Standalone intelligence') }}</span>
                                                    <span v-else-if="mounting_rail.product_subtype === 'presence_detector'">{{ $t('SensorSystem Master') }}</span>
                                                    <span v-else-if="mounting_rail.product_subtype === 'presence_detector_slave'">{{ $t('SensorSystem Slave') }}</span>
                                                    <span v-else>{{ $t(mounting_rail.title) }}</span>
                                                </p>

                                                <div class="mounting-rail-image-wrapper" v-if="product_configurator_id === 3 || !itemIsMountingRail(mounting_rail) || mounting_rail.emergency_light">
                                                    <div class="mounting-rail-image" v-if="mounting_rail.product_type !== 'universal_connector' && mounting_rail.product_subtype !== 'presence_detector' && mounting_rail.product_subtype !== 'presence_detector_slave' && mounting_rail.product_subtype !== 'casambi_10' && mounting_rail.product_subtype !== 'casambi_60' && mounting_rail.product_subtype !== 'enlighted' && mounting_rail.product_subtype !== 'intelligence' && !mounting_rail.emergency_light"></div>
                                                    <div class="mounting-rail-connectors-wrapper" v-if="(product_configurator_id === 3 && mounting_rail.max_modules > 0) || mounting_rail.product_type === 'universal_connector' || mounting_rail.product_subtype === 'presence_detector' || mounting_rail.product_subtype === 'presence_detector_slave' || mounting_rail.product_subtype === 'casambi_10' || mounting_rail.product_subtype === 'casambi_60'  || mounting_rail.product_subtype === 'enlighted' || mounting_rail.product_subtype === 'intelligence' || mounting_rail.emergency_light">
                                                            <div v-if="mounting_rail.product_type === 'universal_connector'" class="mounting-rail-connector" style="width:100%"></div>
                                                            <div v-else-if="mounting_rail.product_subtype === 'presence_detector' || mounting_rail.product_subtype === 'presence_detector_slave' || mounting_rail.product_subtype === 'intelligence'" class="mounting-rail-motion-detector" style="width:100%"></div>
                                                            <div v-else-if="mounting_rail.product_subtype === 'casambi_10' || mounting_rail.product_subtype === 'casambi_60'" class="mounting-rail-casambi" style="width:100%"></div>
                                                            <div v-else-if="mounting_rail.product_subtype === 'enlighted'" class="mounting-rail-enlighted" style="width:100%"></div>
                                                            <div v-else-if="mounting_rail.emergency_light" class="mounting-rail-emergency-light" style="width:100%"></div>
                                                            <div v-else class="mounting-rail-connector" :style="'width:' +  (100 / mounting_rail.max_step) + '%'" v-for="(module, index) in mounting_rail.max_modules"></div>
                                                    </div>
                                                </div>

                                                <nested-draggable
                                                    v-if="product_configurator_id === 1"
                                                    :list="mounting_rail.modules"
                                                    :element="'div'"
                                                    animation="400"
                                                    :group="'modules'"
                                                    ghostClass="drop-area"
                                                    :move="canDropModule"
                                                    @choose="onModuleChoose"
                                                    @unchoose="onModuleUnchoose"
                                                    @add="redistributeModulesAcrossRails"
                                                    :class="'modules-wrapper'"
                                                    filter=".ignore-module"
                                                    :data-mounting-rail-index="index">

                                                    <div v-for="(module, index) in mounting_rail.modules"
                                                         class="luminaire-line-module"
                                                         :class="{
                                                            'led-module': module.type === 'led_module',
                                                            'blind-module': module.type === 'blind_module',
                                                            'ignore-module': module.emergency_light && !module.emergency_light_movable,
                                                            'emergency-light': module.emergency_light && !module.emergency_light_movable,
                                                            'emergency-light-movable': module.emergency_light && module.emergency_light_movable,
                                                            [module.submodule && module.submodule.type]: module.submodule && module.submodule.type
                                                         }"
                                                         :id="'module-' + module.id"
                                                         :data-module-id="module.id"
                                                         :data-module-type="module.type">

                                                        <div class="lighting-module" v-if="!mounting_rail.emergency_light">
                                                            <span :style="module.submodule ? 'font-size:10px;' : ''">{{ getModuleTitleByType(module.type, module.emergency_light, module.submodule) }}</span>
                                                        </div>
                                                        <!-- PIN CONFIGURATION -->
                                                        <div v-show="module.type === 'led_module' && showPinConfiguration"
                                                             class="p-1 bg-dark"
                                                             :style="module.emergency_light ? 'margin-top:-20px;' : 'margin-top: 0.5rem;'">
                                                            <ValidationProvider :name="$t('PIN L')"
                                                                                :vid="'pin_l_' + module.id"
                                                                                :rules="`required|numeric|min:${modulePinHelpers.min_pin}|max:${modulePinHelpers.max_pin}|is_not:${module.pin_n}|excluded:${module.emergency_light ? [modulePinHelpers.emergency_light_pin].concat(modulePinHelpers.pins_to_exclude).concat([module.pin_n, module.pin_not])  : modulePinHelpers.pins_to_exclude.concat([module.pin_n, module.pin_not])}`"
                                                                                v-if="module.type === 'led_module'"
                                                                                immediate
                                                                                tag="div"
                                                                                class="form-group p-0 row m-0 mb-1"
                                                                                v-slot="{ errors }">
                                                                <label class="col-7 m-0 p-0" :for="'pin_l_' + module.id">{{ $t('PIN L') }}</label>
                                                                <input class="col-5 m-0 p-0" type="number" :min="modulePinHelpers.min_pin" :max="modulePinHelpers.max_pin" :name="'pin_l_' + module.id" v-model.number="module.pin_l" />
                                                                <span class="text-danger small" v-if="errors && errors[0]">{{ $t(errors[0]) }}</span>
                                                            </ValidationProvider>
                                                            <ValidationProvider :name="$t('PIN N')"
                                                                                :vid="'pin_n_' + module.id"
                                                                                :rules="`required|numeric|min:${modulePinHelpers.min_pin}|max:${modulePinHelpers.max_pin}|is_not:${module.pin_l}|excluded:${module.emergency_light ? [modulePinHelpers.emergency_light_pin].concat(modulePinHelpers.pins_to_exclude).concat([module.pin_l, module.pin_not])  : modulePinHelpers.pins_to_exclude.concat([module.pin_l, module.pin_not])}`"
                                                                                v-if="module.type === 'led_module'"
                                                                                immediate
                                                                                tag="div"
                                                                                class="form-group p-0 row m-0"
                                                                                v-slot="{ errors }">
                                                                <label class="col-7 m-0 p-0" :for="'pin_n_' + module.id">{{ $t('PIN N') }}</label>
                                                                <input class="col-5 m-0 p-0" type="number" :min="modulePinHelpers.min_pin" :max="modulePinHelpers.max_pin" :name="'pin_n_' + module.id" v-model.number="module.pin_n" />
                                                                <span class="text-danger small" v-if="errors && errors[0]">{{ $t(errors[0]) }}</span>

                                                            </ValidationProvider>
                                                            <div class="form-group p-0 row m-0" v-if="module.emergency_light">
                                                                <div class="col-7 m-0 p-0">PIN NOT</div>
                                                                <div class="col-5 m-0 p-0 pl-1 text-left">{{ module.pin_not }}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </nested-draggable>
                                            </div>
                                </draggable>

                            </div>
                            <div class="luminaire-room-right"></div>
                        </div>
                        <div class="zoom-button-box w-100 text-center">
                            <button class="btn shadow-sm bg-light" @click.prevent id="zoomInButton"><i class="fas fa-plus"></i></button>
                            <button class="btn shadow-sm bg-light" @click.prevent id="zoomOutButton"><i class="fas fa-minus"></i></button>
                            <button class="btn shadow-sm bg-light" @click.prevent id="resetLocation"><i class="fas fa-location-arrow"></i></button>

                            <div class="d-inline-block mr-3 ml-3" v-if="product_configurator_id === 1">
                                <button class="btn btn-primary shadow-sm" @click.prevent="showPinConfiguration = !showPinConfiguration">
                                    <span v-if="!showPinConfiguration">{{ $t('Show PIN configuration')}}</span>
                                    <span v-else>{{ $t('Hide PIN configuration')}}</span>
                                </button>
                                <button class="btn bg-light shadow-sm" @click.prevent="showResetModulePinDataModal" v-if="showPinConfiguration">
                                    <span>{{ $t('Set to default PIN configuration')}}</span>
                                </button>
                            </div>

                            <button class="btn btn-primary shadow-sm" @click.prevent="updateModuleOrder('save', valid, errors)" :disabled="mountingRailArrangementFormSubmitting">
                                <span><i class="far fa-save" :title="$t('Save')"></i></span>
                            </button>
                            <button class="btn btn-primary shadow-sm" @click.prevent="updateModuleOrder('save_close', valid, errors)" :disabled="mountingRailArrangementFormSubmitting">
                                <span v-if="!mountingRailArrangementFormSubmitting">{{ $t('Save & finish') }}</span>
                                <span v-else>{{ $t('Save') }}...</span>
                            </button>
                            <div class="w-100 text-center pt-2" v-if="showPinConfiguration">
                                <p>{{ $t('Possible PIN-configuration') }}: {{ formattedPossiblePins }}</p>
                            </div>
                        </div>

                    </ValidationObserver>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import draggable from 'vuedraggable'
import nestedDraggable from 'vuedraggable'
import Panzoom from '@panzoom/panzoom'
import {mapGetters} from "vuex";

export default {

    components: {
        draggable,
        nestedDraggable
    },

    data() {
        return {
            loading: false,
            product_configurator_id: null,
            planningFields: {},
            mountingRailArrangementForm: {
                mounting_rail_arrangement: '',
            },
            errors: {},
            mountingRailArrangementFormSubmitting: false,
            luminaireLineModules: [],
            panzoomActive: false,
            firstTimeOpened: false,
            showPinConfiguration: false,
            pinConfigurationPopupCounter: 0,

            mountingRailAndModuleArrangement: [],

            modulePinHelpers: {},
            ledModuleCounter: 0,

            moduleDragging: false,

            products: [],

            loadedApiCalls: {
                products: false,
                planning: false,
                helpers: false,
                mountingRailData: false,
            },

            allApiCallsFinished: false,

        };
    },

    created() {
        this.loadProducts();
        this.getPlanning();
    },

    methods: {

        getMountingRailsLength(mountingRails) {
            let length = 0;

            for (let i = 0; i < mountingRails.length; i++) {
                length += this.getItemLength(mountingRails[i]);
            }

            return length;
        },

        getItemLength(item) {
            if (this.itemIsMountingRail(item)) {
                return item.length;
            }
            // Intelligence standalone modules are physically 28 cm but displayed as 168 px (standard width) for usability
            if (item && item.product_subtype === 'intelligence' && item.product_type === 'luminaire_control') {
                return 168;
            }
            // Integrated intelligence should not add length (size_x = 0) and is not draggable; fall back to 168 for generic modules
            return 168;
        },

        getMountingRailById(id) {
            return this.products.mountingrail
                .concat(this.products.mountingrail_with_connectors)
                .find(product => product.id === id);
        },

        itemIsMountingRail(mountingRail) {
            return mountingRail.product_type === 'mountingrail' || mountingRail.product_type === 'mountingrail_with_connectors';
        },

        /**
         * Load data from API
         */

        getPlanning() {
            this.loading = true;
            axios.get('/api/plannings/' + this.$route.params.id + '?product_configurator_id=' + this.product_configurator_id + '&paginate=0&separate_blind_modules=1')
                .then(response => {
                    this.planningFields = response.data.data;
                    this.product_configurator_id = this.planningFields.product_configurator_id;
                    this.loadedApiCalls.planning = true;
                    if (this.product_configurator_id === 1) {
                        this.getModulePinHelpers();
                    } else {
                        this.loadedApiCalls.helpers = true;
                    }
                    this.setMountingRailData(JSON.parse(this.planningFields.mounting_rail_arrangement));
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                });
        },

        getModulePinHelpers() {
            axios.get('/api/plannings/' + this.$route.params.id + '/get_module_pin_helpers')
                .then(response => {
                    this.modulePinHelpers = response.data;
                    this.loadedApiCalls.helpers = true;
                }).catch(error => {
                    console.log(error);
                });
        },

        setMountingRailData(mountingRailData) {
            mountingRailData.forEach((mountingRail, mountingRailIndex) => {
                mountingRail.modules.forEach( (module, moduleIndex) => {
                    module.id = (mountingRailIndex + 1) + '_' + (moduleIndex + 1);
                });
                return mountingRail.id = mountingRailIndex + 1;
            });

            this.mountingRailAndModuleArrangement = mountingRailData;

            if (this.$can('access_all_projects')) {
                console.log(this.mountingRailAndModuleArrangement, this.planningFields, '<<< DEBUG: Rechtsklick auf {...} oder "Object" und "Copy Object" & an f.brunner@des21.com senden');
            }

            this.loadedApiCalls.mountingRailData = true;
        },

        showResetModulePinDataModal() {

            this.$swal.fire({
                title: this.$t('Do you want to reset the PIN-configuration?'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e3342f',
                cancelButtonColor: '#393e42',
                confirmButtonText: this.$t('Yes, reset!'),
                cancelButtonText: this.$t('Cancel')
            }).then((result) => {
                if (result.value) {
                    this.resetModulePinData();

                }
            });
        },

        getModuleTitleByType(type, emergency_light = false, submodule = null) {

            if (type === 'led_module') {
                return !emergency_light ? this.$t('LED module') : this.$t('Emergency light');
            }

            if (type === 'blind_module' && !submodule) {
                return this.$t('Blind module');
            }

            if (type === 'blind_module' && submodule && submodule.type === 'luminaire_control_submodule') {
                let subtype = submodule.product_subtype;
                // Fallback: lookup subtype from loaded products if missing in submodule data
                if (!subtype && this.products && this.products.length > 0) {
                    const p = this.products.find(x => x.id === submodule.product_id);
                    if (p) subtype = p.product_subtype;
                }

                if (subtype === 'intelligence') {
                    return this.$t('Integrated intelligence');
                }
                return this.$t('SensorSystem Master');
            }

            if (type === 'blind_module' && submodule && submodule.type === 'luminaire_control_submodule_slave') {
                return this.$t('SensorSystem Slave');
            }

            if (type === 'blind_module' && submodule && submodule.type === 'universal_connector_submodule') {
                return this.$t('Universal connector lite V1');
            }

            if (type === 'blind_module' && submodule && submodule.type === 'universal_connector_submodule_v2') {
                return this.$t('Universal connector lite V2');
            }

            if (type === 'blind_module' && submodule && submodule.type === 'universal_connector_submodule_v3') {
                return this.$t('Universal connector lite V3');
            }

            return this.$t(type);
        },

        getEmergencyLightImage(mounting_rail) {
            if (this.planningFields.type_of_emergency_light && mounting_rail.emergency_light) {
                return this.getProductImageById(this.planningFields.type_of_emergency_light);
            }

        },

        getProductImageById(id) {
            if (!this.products || this.products.length < 1) {
                return '';
            }

            let product = this.products.find(product => product.id === id);
            let image_url = this.$i18n.locale === 'en' && product.picture_file_name_en ? product.picture_file_name_en : product.picture_file_name;
            return image_url ? 'productimages/' + image_url : '';
        },

        resetModulePinData() {

            this.ledModuleCounter = 0;
            this.mountingRailAndModuleArrangement.forEach(mountingRail => {
                mountingRail.modules.forEach(module => {
                    if (module.type === 'led_module') {
                        module.pin_l = this.getModulePinL(module);
                        module.pin_n = this.modulePinHelpers.default_pin_n[this.ledModuleCounter % this.modulePinHelpers.default_pin_n.length];
                        module.pin_not = module.emergency_light ? this.modulePinHelpers.emergency_light_pin : null;

                        this.ledModuleCounter++;
                    } else {
                        module.pin_l = null;
                        module.pin_n = null;
                        module.pin_not = null;
                    }
                });
            });

            this.$swal.fire({
                icon: 'success',
                title: this.$t('PIN configuration set to default'),
            });

        },

        getModulePinL(module) {
            let max_repeats = this.modulePinHelpers.default_pin_l.length;
            let i = 0;

            while (i < max_repeats) {
                if (!this.modulePinHelpers.default_pin_l[this.ledModuleCounter % this.modulePinHelpers.default_pin_l.length]) {
                    return null;
                }

                let pin_l = this.modulePinHelpers.default_pin_l[this.ledModuleCounter % this.modulePinHelpers.default_pin_l.length];

                if (!module.subtype || module.subtype !== 'emergency_light' || pin_l !== this.modulePinHelpers.emergency_light_pin) {
                    return pin_l;
                }

                i++;
                this.ledModuleCounter++;
            }

        },

        loadProducts() {
            this.loading = true;
            axios.get('/api/luminaire_line_products?enabled=1')
                .then(response => {
                    this.products = Object.keys(response.data).map(key => {
                        return response.data[key];
                    });
                    this.loadedApiCalls.products = true;
                }).catch(error => {
                    console.log(error);
                });
        },

        getMountingRailConfigurationByTitle(title) {
            const regex = /(Mounting rail (Eco|Max) \d+\.\d+ m) \((\d+ electrical connector[s]?)\)/;
            let match = title.match(regex);

            if (match) {
                return {
                    title: match[1],
                    serie: match[2],
                    connectors: match[3],
                };
            } else {
                return false;
            }
        },

        /**
         * Vue draggable functions
         */

        onModuleChoose(event) {
            if (event.item.dataset.moduleType && (event.item.dataset.moduleType === 'led_module' || event.item.dataset.moduleType === 'blind_module')) {
                this.moduleDragging = true;
            }
        },

        onModuleUnchoose(event) {
            this.moduleDragging = false;
        },

        // vuedraggable has already moved the dragged module across rails before @add
        // fires, leaving the source at max-1 and the target at max+1. Flatten the
        // post-drag sequence and re-slice it along each rail's max_modules to
        // restore the "every rail holds exactly max_modules" invariant while
        // preserving the overall module order. Pinned rails (168mm emergency rails
        // and 0-slot standalone items) are excluded — canDropModule blocks cross-rail
        // drops into them. Modules are spliced in place so the array identity stays
        // stable and nested-draggable avoids unnecessary re-initialization.
        redistributeModulesAcrossRails() {

            let mutableRails = this.mountingRailAndModuleArrangement.filter(rail =>
                rail.max_modules > 0 && !rail.emergency_light
            );

            let flat = mutableRails.flatMap(rail => rail.modules);

            let pointer = 0;
            mutableRails.forEach(rail => {
                let slice = flat.slice(pointer, pointer + rail.max_modules);
                rail.modules.splice(0, rail.modules.length, ...slice);
                pointer += rail.max_modules;
            });
        },

        canDropModule(event) {

            let targetRail = this.mountingRailAndModuleArrangement[event.to.dataset.mountingRailIndex];
            if (!targetRail) return true;

            // Standalone items (universal_connector, intelligence, casambi,
            // presence_detector, enlighted) have max_modules = 0 — never accept a module.
            if (targetRail.max_modules === 0) return false;

            // 168mm emergency-light rails must keep their pinned emergency LED.
            if (targetRail.emergency_light) return false;

            return true;
        },

        /**
         * Set the luminaire line modules
         */

        updateModuleOrder(action, valid) {
            if (!valid) {
                this.$swal.fire({
                    icon: 'error',
                    title: this.$t('All PINs must be valid and filled in'),
                    text: this.formattedPossiblePins,
                });
                return;
            }
            this.mountingRailArrangementFormSubmitting = true;
            this.setMountingRailArrangementForm();
            axios.put('/api/plannings/' + this.$route.params.id + '/mounting_rail_arrangement', this.mountingRailArrangementForm)
                .then(response => {
                    this.mountingRailArrangementFormSubmitting = false;
                    if (this.planningFields.mounting_rail_arrangement) {
                        this.$swal.fire({
                            icon: 'success',
                            title: this.$t('Saved successfully'),
                            confirmButtonColor: '#3CA2A4'
                        });
                    }
                    if (action === 'save_close') {
                        this.$router.push({ name: 'plannings.show', params: { id: this.$route.params.id} } );
                    }
                }).catch(error => {
                    this.$swal.fire({ icon: 'error', title: this.$t('There was an error') + ' (' + error.response.status + ')' , confirmButtonColor: '#3CA2A4'});
                    if (error.response.status === 422) { // Validation Error
                        this.errors = error.response.data.errors;
                    }

                    this.mountingRailArrangementFormSubmitting = false;
                });
        },

        setMountingRailArrangementForm() {
            this.mountingRailArrangementForm.mounting_rail_arrangement = JSON.stringify(this.mountingRailAndModuleArrangement);
        },

        /**
         * General helpers & functions
         */

        loadPanzoom() {

            const elem = document.getElementById('luminaire-line-order-zoom');
            const zoomInButton = document.getElementById('zoomInButton');
            const zoomOutButton = document.getElementById('zoomOutButton');
            const resetButton = document.getElementById('resetLocation');

            const panzoom = Panzoom(elem, {
                startScale: 0.7,
                cursor: 'grab',
                excludeClass: 'luminaire-line-order',
                overflow: 'visible',
                animate: true,
                maxScale: 1,
                origin: '0% 0%'
            });

            zoomInButton.addEventListener('click', panzoom.zoomIn)
            zoomOutButton.addEventListener('click', panzoom.zoomOut)
            resetButton.addEventListener('click', panzoom.reset)

        },

        distributeEvenly(ledModules, blindModules) {
            // xs has the smaller length
            const _evenDist = (xs, ys, count = Math.round (ys.length / (xs.length + 1))) =>
                xs.length === 0
                    ? [... ys]
                    : [... ys.slice (0, count), xs[0], ..._evenDist (xs .slice (1), ys .slice (count))]

            const evenDist = (xs, ys) =>
                xs .length > ys.length ? _evenDist(ys, xs) : _evenDist(xs, ys)

            return evenDist (Object.values(ledModules), Object.values(blindModules));
        },

        /** CSS classes */
        getClassObject(mounting_rail) {
            return {
                'mounting-rail': true,
                [mounting_rail.product_type]: true,
                [mounting_rail.product_subtype]: true,
                [mounting_rail.db_title]: this.itemIsMountingRail(mounting_rail),
                'product_addon': !this.itemIsMountingRail(mounting_rail),
                'ignore-element drop-area': this.product_configurator_id === 1 && this.itemIsMountingRail(mounting_rail) && !mounting_rail.emergency_light,
                'ignore-element': mounting_rail.product_subtype == 'enlighted',
                'emergency-light': mounting_rail.emergency_light
            };
        }


    },

    watch: {
        'showPinConfiguration': {
            handler: function (val, oldVal) {
                if (val && this.pinConfigurationPopupCounter < 1) {

                    this.$swal.fire({
                        imageUrl: this.asset(this.modulePinHelpers.pin_image_url),
                        imageWidth: 300,
                        title: this.$t('Possible PIN configurations'),
                        text: this.formattedPossiblePins,
                        confirmButtonColor: '#3CA2A4'
                    });

                    this.pinConfigurationPopupCounter++;
                }
            }
        },
        'loadedApiCalls': {
            handler: function (val, oldVal) {
                if (Object.values(val).every(v => v === true)) {
                    this.allApiCallsFinished = true;
                    this.loadPanzoom();
                    this.loading = false;
                }
            },
            deep: true
        },
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),

        // Shared string for inline hint + popup + validation modal.
        formattedPossiblePins() {
            const possiblePins = this.modulePinHelpers && Array.isArray(this.modulePinHelpers.possible_pins)
                ? this.modulePinHelpers.possible_pins
                : [];

            if (!possiblePins.length) {
                return '';
            }

            return possiblePins.join(', ');
        },
    }

};
</script>
